import React from "react";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import useTemplateInfoModal from "@hooks/use-template-info-modal";

import StorePreviewImage from "@sharedComponents/store-preview-image";
import ContentLinks from "@sharedComponents/content-links";
import { ExternalLinkButton } from "@sharedComponents/buttons";

import { stopEventPropagation } from "@stadium/helpers/resource";
import { shopDetailMarketingPageAbsent } from "@helpers/shop";
import { getShopSendItemsRoute } from "@helpers/routes";

import { MOMENTS, getShopDetailPageRoute } from "@constants/routes";

import styles from "./purge-main.module.scss";

const defaultObj = {};

const ListTemplateView = (hit) => {
  const {
    topBannerImage,
    sampleProductsImage,
    storeName,
    feUrl,
    shortDescription,
    storeNumber,
    storeCode,
    type = "",
    config = defaultObj,
    pageName = "",
    onTemplateSelect = () => {},
  } = hit;
  const [openTemplateInfoModal, renderTemplateInfoModal] = useTemplateInfoModal(hit);
  const isMomentPage = pageName === MOMENTS;
  const { push } = useRouter();

  const renderListTiles = () => (
    <>
      <div className={styles.templateImageContainer}>
        <StorePreviewImage
          topBanner={topBannerImage}
          productsThumbImage={sampleProductsImage}
          width={554}
          height={440}
          className={styles.templateBanner}
          topBannerClassName={styles.templateBannerTopImage}
          bottomBannerClassName={styles.templateBannerBottomImage}
        />
      </div>

      <div className={styles.templateTileContentBlock}>
        <div className={styles.templateTileContentTitle} tabIndex={0}>
          {shopDetailMarketingPageAbsent(config, type) || isMomentPage ? (
            storeName
          ) : (
            <a href={getShopDetailPageRoute(storeCode)} onClick={stopEventPropagation}>
              {storeName}
            </a>
          )}
        </div>
        <div className={styles.templateTileContentDescription}>{shortDescription}</div>
        <div className={styles.templateTileContentLinkRow}>
          <ContentLinks
            useTemplateCtaClassName={styles.templateTileContentLink}
            previewTemplateCtaClassName={styles.templateTileContentLink}
            type={type}
            feUrl={feUrl}
            pageName={pageName}
            storeName={storeName}
            storeNumber={storeNumber}
            onTemplateSelect={onTemplateSelect}
          />
        </div>
      </div>
    </>
  );

  return (
    <>
      <ExternalLinkButton
        className={`${styles.templateTileHolder} ${isMomentPage ? styles.cardHover : ""}`}
        onClick={() => {
          if (isMomentPage) return push(getShopSendItemsRoute(feUrl));
          return openTemplateInfoModal();
        }}
        btnStyle="no-style"
      >
        {renderListTiles()}
      </ExternalLinkButton>
      {renderTemplateInfoModal}
    </>
  );
};

export default ListTemplateView;
